import type { BlogCategoryExtraData } from '@bulknutrients/bulk-shared-lib/interfaces/Blog';

import { Paragraph } from '@components/Typography/Paragraph/Paragraph';
import type { ReactElement } from 'react';

function BlogHeading({
  category,
  blogCategoryExtraData,
}: {
  category?: string;
  blogCategoryExtraData?: BlogCategoryExtraData;
}) {
  let headingText = '';

  if (blogCategoryExtraData?.id) {
    // show custom heading if blog page data exists
    headingText = blogCategoryExtraData.heading;
  } else if (category) {
    // fall back to category name for blog categories without custom data
    headingText = `${category} Blogs`;
  } else {
    // fall back to default for blog page
    headingText = 'The Bulk Nutrients Blog';
  }

  return <h1>{headingText}</h1>;
}

function BlogIntroParagraph({
  blogCategoryExtraData,
}: {
  blogCategoryExtraData?: BlogCategoryExtraData;
}) {
  // show custom description if blog page data exists
  if (blogCategoryExtraData?.id) {
    return <Paragraph>{blogCategoryExtraData.pageDescription}</Paragraph>;
  }

  // fall back
  return (
    <>
      <Paragraph>
        Welcome to the Bulk Nutrients Blog - your one stop shop for news,
        product information, healthy recipes, workouts and more! We're
        constantly adding and updating content, so be sure to throw us a
        bookmark and check back often.
      </Paragraph>
      <Paragraph>
        Browse the posts in chronological order below or narrow down by topic
        using the navigation.
      </Paragraph>
      <Paragraph>Oh, and enjoy!</Paragraph>
    </>
  );
}

export function BlogIntro({
  category,
  blogCategoryExtraData,
}: {
  category?: string;
  blogCategoryExtraData?: BlogCategoryExtraData;
}): ReactElement {
  return (
    <section className="max-w-[640px] justify-self-center">
      <BlogHeading
        category={category}
        blogCategoryExtraData={blogCategoryExtraData}
      />
      <BlogIntroParagraph blogCategoryExtraData={blogCategoryExtraData} />
    </section>
  );
}
